import { render, staticRenderFns } from "./template-popup.vue?vue&type=template&id=ce62e7c0&scoped=true"
import script from "./template-popup.vue?vue&type=script&lang=js"
export * from "./template-popup.vue?vue&type=script&lang=js"
import style0 from "./template-popup.vue?vue&type=style&index=0&id=ce62e7c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce62e7c0",
  null
  
)

export default component.exports